import {collaborator} from 'constants/url';
import {useUpdateWithPDF} from 'components/hooks/useUpdate';
import {EditingOptions} from 'components/grid-dx/types';

function useUpdateCollabo() {
  const updateCollabo = useUpdateWithPDF(collaborator);
  return (editOptions: EditingOptions) => updateCollabo(editOptions);
}

export default useUpdateCollabo;
